import {ChangeDetectionStrategy, Component} from '@angular/core';
import {VisitContext} from '../../../visit-context';
import {sendCommand} from '../../../../common/utils';
import {DeclarationType, ResendCargoImport, ResubmitCargoImport} from '@portbase/bezoekschip-service-typescriptmodels';
import {AppContext} from '../../../../app-context';
import {DeclarationUtils} from "../../../../refdata/declaration-utils";

@Component({
    selector: 'app-cargo-import-admin',
    templateUrl: './cargo-import-admin.component.html',
    styleUrls: ['./cargo-import-admin.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CargoImportAdminComponent {
  context = VisitContext;
  appContext = AppContext;

  resend() {
    AppContext.clearVisitAlerts();
    sendCommand('com.portbase.bezoekschip.common.api.cargo.ResendCargoImport', <ResendCargoImport>{
      crn: VisitContext.savedVisit.crn,
      cargoDeclarantShortName: VisitContext.cargoImportModel.cargoDeclarant.shortName
    }, () => AppContext.registerSuccess('The import declarations were resend successfully'))
  }

  resendAllowed() {
    return this.context.cargoImportModel.declarations.length !== 0 && !this.resubmitAllowed();
  }

  resubmit() {
    AppContext.clearVisitAlerts();
    sendCommand('com.portbase.bezoekschip.common.api.cargo.ResubmitCargoImport', <ResubmitCargoImport>{
      crn: VisitContext.savedVisit.crn,
      cargoDeclarantShortName: VisitContext.cargoImportModel.cargoDeclarant.shortName
    }, () => AppContext.registerSuccess('The import declarations were resubmitted successfully'))
  }

  resubmitAllowed() {
    return this.context.cargoImportModel.manifests.some(m => (m.consignments.length !== 0 || m.containers.length !== 0)
      && m.declarations &&
        (m.declarations.some(d => d && d.status === 'DECLARED' && d.type == 'SDT')
          && !DeclarationUtils.getLastDeclarations(m.declarations, [DeclarationType.ENS])
            .some(d => d && d.status === 'REJECTED')));
  }
}
